"use client";

import {
    GridLayout,
    SelectedGridLayout,
    ListLayout,
    SelectedListLayout,
} from "@/public/Theme";
import Image from "next/image";
import useStore from "@/lib/Store/useStore";

const ProductLayoutToggler = () => {
    const { setLayout, layout } = useStore();

    const modes = [
        { icon: GridLayout, value: "grid", selectedIcon: SelectedGridLayout },
        { icon: ListLayout, value: "list", selectedIcon: SelectedListLayout },
    ];

    return (
        <div className="flex items-center gap-x-4">
            {modes.map((l, index) => {
                return (
                    <Image
                        onClick={() => setLayout?.(l?.value)}
                        className="cursor-pointer"
                        src={l?.value == layout ? l?.selectedIcon : l?.icon}
                        width={30}
                        height={30}
                        alt={l?.value}
                        key={index}
                    />
                );
            })}
        </div>
    );
};
export default ProductLayoutToggler;
